import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Accommodation from './screens/Accommodation/Accommodation';
import Home from './screens/Home/Home';
import Planning from './screens/Planning/Planning';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import ToolbarMenu from './ToolbarMenu';
import LanguageSelector from './components/LanguageSelector';
import logo from './logo.png';
import './App.css';
import './Toolbar.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, [pathname]);

  return null;
};

const App = () => {
  const { t } = useTranslation();
  
  const isSmAndMore = useMediaQuery('(min-width:600px)');

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <AppBar
          position="fixed"
          style={{
            backgroundColor: '#1c1c1c',
            height: 56,
            zIndex: 10000,
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Toolbar className="toolbar">
            <img src={logo} alt="logo" className="toolbar-logo" />

            {isSmAndMore ? (
              <>
                <Typography className="toolbar-menu">
                  <NavLink
                    to="/"
                    className={({ isActive }) => `toolbar-nav-link nav-link ${isActive ? 'active' : ''}`}
                  >
                    {t("menu.0")}
                  </NavLink>

                  <NavLink
                    to="/planning"
                    className={({ isActive }) => `toolbar-nav-link nav-link ${isActive ? 'active' : ''}`}
                  >
                    {t("menu.1")}
                  </NavLink>

                  <NavLink
                    to="/accommodation"
                    className={({ isActive }) => `toolbar-nav-link nav-link ${isActive ? 'active' : ''}`}
                  >
                    {t("menu.2")}
                  </NavLink>
                </Typography>
                <LanguageSelector />
              </>
            ) : (
              <>
                <div className="toolbar-menu">
                  <ToolbarMenu />
                </div>
              </>
            )}
          </Toolbar>
        </AppBar>

        {/* Contenu principal */}
        <div style={{ marginTop: 56 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/planning" element={<Planning />} />
            <Route path="/accommodation" element={<Accommodation />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;